<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="사용자 관리" device="web">
        <template v-slot:body>
          <v-layout column overflow-auto>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="userDataGrid"
                  width="100%"
                  class="layout-col-height00"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="false"
                  :show-borders="true"
                  :show-row-lines="true"
                  key-expr="id"
                  :focused-row-enabled="true"
                  @editing-start="onEditingStart"
                  @editor-preparing="onEditorPreparing"
                  @focused-row-changed="handleFocusedRow"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />
                  <DxColumn
                    data-field="clntId"
                    data-type="string"
                    width="200px"
                    alignment="left"
                    caption="고객명"
                    css-class="devest-grid-header-require"
                    cell-template="clntDisplay"
                    edit-cell-template="customClntGrid"
                  />
                  <template #clntDisplay="{ data: cellInfo }">{{ clntDisplay(cellInfo) }}</template>
                  <template #customClntGrid="{ data: cellInfo }">
                    <CustomDropBoxGridTemplate
                      :cellInfo="cellInfo"
                      :dataSource="clntIdList"
                      :options="clntTemplateOpts"
                      @onSelectionChanged="onSelectionChanged($event, cellInfo, clntIdList, 'clntId')"
                    />
                  </template>
                  <DxColumn
                    data-field="rgstNo"
                    data-type="string"
                    width="150px"
                    alignment="left"
                    caption="사업자 등록번호"
                    css-class="devest-grid-header-require"
                  />
                  <DxColumn
                    data-field="userCd"
                    data-type="string"
                    width="100px"
                    alignment="left"
                    caption="아이디"
                    css-class="devest-grid-header-require"
                  />

                  <DxColumn
                    data-field="userNm"
                    data-type="string"
                    width="120px"
                    alignment="center"
                    caption="사용자 명"
                    css-class="devest-grid-header-require"
                  />

                  <!-- <DxColumn
                        data-field="esgHrNo"
                        data-type="string"
                        width="100px"
                        alignment="left"
                        caption="인원연결"
                        edit-cell-template="checkNoEditor"
                      >
                        <DxLookup
                          :data-source="esgHrNoListLookup"
                          value-expr="esgHrNo"
                          display-expr="checkTargetNm"
                        />
                      </DxColumn>

                      <template #checkNoEditor="{ data: cellInfo }">
                        <DevLookup
                          :data-source="dataSource(cellInfo)"
                          :value="cellInfo.value"
                          placeholder
                          :grouped="true"
                          value-expr="esgHrNo"
                          display-expr="displayCheckNm"
                          @value-changed="onHrValueChanged($event, cellInfo)"
                        >
                          <DxDropDownOptions
                            width="250px"
                            title="해당 인원을 선택하세요"
                            :close-on-outside-click="true"
                          />
                        </DevLookup>
                  </template>-->

                  <DxColumn
                    data-field="userPs"
                    data-type="string"
                    width="120px"
                    alignment="left"
                    caption="패스워드"
                    :calculate-display-value="getUserPsHide"
                    css-class="devest-grid-header-require"
                  />
                  <DxColumn
                    data-field="userPsCheck"
                    data-type="string"
                    width="120px"
                    alignment="left"
                    caption="패스워드확인"
                    :calculate-display-value="getUserPsHide"
                    css-class="devest-grid-header-require"
                  />
                  <DxColumn
                    data-field="psChked"
                    data-type="boolean"
                    width="120px"
                    alignment="center"
                    caption="패스워드변경"
                    edit-cell-template="checkBoxEditorPs"
                  />
                  <DxColumn
                    data-field="비밀번호 초기화"
                    width="140px"
                    alignment="center"
                    cell-template="initPassword"
                    edit-cell-template="initPassword"
                  />
                  <template #initPassword="{data: cellInfo}">
                    <v-btn
                      v-if="!cellInfo.data.__created__"
                      elevation="0"
                      color="btn_sub"
                      dark
                      x-small
                      class="rounded ml-2"
                      @click="initialize(cellInfo.data)"
                      >초기화</v-btn
                    >
                  </template>
                  <DxColumn data-field="loginFailCnt" data-type="string" width="150px" alignment="center" caption="로그인 실패 카운트" />

                  <DxColumn
                    data-field="grpAuthCd"
                    data-type="string"
                    width="120px"
                    alignment="left"
                    caption="권한그룹"
                    css-class="devest-grid-header-require"
                  >
                    <DxLookup :data-source="selectList" value-expr="grpAuthCd" display-expr="grpAuthNm" />
                  </DxColumn>
                  <!--<DxColumn data-field="empNo" data-type="string" width="80px" alignment="left" caption="사번" />-->
                  <!--<DxColumn data-field="hpNo" data-type="string" width="120px" alignment="left" caption="휴대전화번호" />-->
                  <!-- <DxColumn
                        data-field="userStatus"
                        data-type="string"
                        width="60px"
                        alignment="center"
                        caption="상태"
                        css-class="devest-grid-header-require"
                      >
                        <DxLookup
                          :data-source="userStatusList"
                          value-expr="minorCd"
                          display-expr="minorNm"
                        />
                  </DxColumn>-->

                  <DxColumn
                    data-field="useYn"
                    data-type="boolean"
                    width="50px"
                    alignment="center"
                    caption="사용"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="connDtS"
                    data-type="string"
                    width="150px"
                    alignment="center"
                    caption="접속허용 시작일"
                    edit-cell-template="dateEditor"
                    css-class="devest-grid-header-require"
                  />

                  <DxColumn
                    data-field="connDtE"
                    data-type="string"
                    width="150px"
                    alignment="center"
                    caption="접속허용 종료일"
                    edit-cell-template="dateEditor"
                    css-class="devest-grid-header-require"
                  />
                  <template #dateEditor="{ data: cellInfo }">
                    <div>
                      <DxDateBox
                        :value="cellInfo.value"
                        type="date"
                        picker-type="calendar"
                        display-format="yyyy.MM.dd"
                        :use-mask-behavior="true"
                        @value-changed="onDateValueChanged($event, cellInfo)"
                      />
                    </div>
                  </template>

                  <DxColumn
                    data-field="enableAlarmAllYn"
                    data-type="boolean"
                    width="200px"
                    alignment="center"
                    caption="전체알람수신 동의여부"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="enableAlarmEduYn"
                    data-type="boolean"
                    width="200px"
                    alignment="center"
                    caption="교육알람수신 동의여부"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="enableAlarmHealthYn"
                    data-type="boolean"
                    width="200px"
                    alignment="center"
                    caption="건강알람수신 동의여부"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="lastLoginOs"
                    data-type="string"
                    width="140px"
                    alignment="center"
                    caption="마지막 접속 OS"
                    :allow-editing="false"
                  />

                  <DxColumn data-field="email" data-type="string" width="150px" alignment="left" caption="이메일" />

                  <DxColumn data-field="hpNo" data-type="string" width="150px" alignment="center" caption="휴대전화번호" />

                  <DxColumn data-field="remark" data-type="string" alignment="left" caption="비고" />

                  <!-- <template #textBoxEdior="{ data: selectRows }">
                      <DxTextBox :mode="passwordMode" :value="selectRows.value" :onValueChanged="value => onValueChanged(value, selectRows)" />
                  </template>-->

                  <template #checkBoxEditorPs="{ data: selectRows }">
                    <DxCheckBox :value="selectRows.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChangedPs(value, selectRows)" />
                  </template>

                  <template #checkBoxEditor="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right
        :useBtnList="buttonUseList"
        @btnAdd="btnAdd()"
        @btnSearch="btnSearch()"
        @btnSave="btnSave()"
        @btnDelete="btnDelete()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn, DxLookup, DxEditing, DxSelection } from 'devextreme-vue/data-grid'
import { DxLookup as DevLookup, DxDropDownOptions } from 'devextreme-vue/lookup'
import DxCheckBox from 'devextreme-vue/check-box'
import iButtonList from '@/components/common/iButtonList.vue'
import iPageTitle from '@/components/common/iPageTitle.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { getUserListByCompId, getUserListInfo, getUserAuthList, saveUserList, deleteUserList, initPassword } from '@/api/system/userManage'
import { getGrpAuth, getCommonCode } from '@/api/common/commonApi'
import { getCompanyList } from '@/api/baseManage/compManage'
import notify from 'devextreme/ui/notify'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256' //cyrptojs 적용(aes256)
import { DxTextBox } from 'devextreme-vue/text-box'
import { getHrJbrpApi } from '@/api/baseManage/esgHRManage'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getClientList } from '@/api/setting/clientManage'
import CustomDropBoxGridTemplate from '@/components/dxDataGrid/CustomDropBoxGridTemplate.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'userManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop,
    'i-page-title': iPageTitle,
    iButtonList,
    DxDataGrid,
    DxColumn,
    DxCheckBox,
    DxLookup,
    DxEditing,
    DxSelection,
    DxTextBox,
    DxLookup,
    DevLookup,
    DxDropDownOptions,
    DxDateBox,
    CustomDropBoxGridTemplate
  },
  data() {
    return {
      groupKey: '',
      dxDataGridRef: 'userDataGrid',
      gridMain: [],
      valid: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      allMode: 'allPages',
      grpAuthCd: '',
      phonePattern: /^\d{3}-(\d{4}||\d{3})-\d{4}$/i,
      clntIdList: [],
      selectList: [], //사용자그룹권한
      focusData: [],
      esgHrNoList: [],
      esgHrNoListSource: [],
      esgHrNoListLookup: [],
      //패스워드 안보이게 처리
      passwordMode: 'password',
      clntTemplateOpts: {
        dropBoxWidth: '500px',
        gridWidth: '100%',
        displayExpr: 'clntNm',
        valueExpr: 'clntId',
        keyExpr: 'clntId',
        selectionMode: 'single',
        columns: [
          {
            fieldCd: 'clntId',
            fieldNm: '고객아이디',
            width: '200px'
          },
          {
            fieldCd: 'clntNm',
            fieldNm: '고객명',
            width: '250px'
          }
        ]
      },
      compTemplateOpts: {
        dropBoxWidth: '500px',
        gridWidth: '100%',
        displayExpr: 'compNm',
        valueExpr: 'compId',
        keyExpr: 'compId',
        selectionMode: 'single',
        columns: [
          {
            fieldCd: 'compId',
            fieldNm: '사업장아이디',
            width: '200px'
          },
          {
            fieldCd: 'compNm',
            fieldNm: '사업장명',
            width: '250px'
          }
        ]
      }
    }
  },

  beforeMount() {
    let grpParams = {
      platformType: 'M'
    }

    Promise.all([
      getCommonCode('CM006'),
      getCompanyList({ clntId: this.getClntId() }),
      getGrpAuth(grpParams),
      getHrJbrpApi({ compId: '' }),
      getClientList({ validOnly: true }, false)
    ]).then(response => {
      let failedResponse = response.find(element => !element.success)
      if (failedResponse == null) {
        //상태
        // this.userStatusList = response[0].list.slice()
        //회사
        //권한
        this.selectList = response[2].list.slice()

        this.esgHrNoList = []
        this.esgHrNoList = response[3].list.slice()

        var esgHrNoListSource = response[3].list.filter(element => element.key !== '기타' && element.key !== '전체')
        this.esgHrNoListLookup = esgHrNoListSource.reduce((acc, val) => acc.concat(val.items), [])

        this.clntIdList = response[4].list.slice()
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  mounted() {
    this.btnSearch()
  },
  methods: {
    dataSource(cellInfo) {
      let items = this.esgHrNoList[0].items.filter(element => element.compId == cellInfo.data.compId)
      let dataSource = [
        {
          items: items,
          key: '인원',
          sort: 0
        }
      ]
      return dataSource
    },
    async signIn() {
      return new Promise(async (resolve, reject) => {
        this.GetDataGrid(this.dxDataGridRef).saveEditData()
        var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()

        //cyrptojs 적용(aes256) 20220404 by lyj
        selectedRows.forEach(element => {
          element.userPs = AesEncrypt(element.userPs)
          element.userPsCheck = AesEncrypt(element.userPsCheck)
        })
        //console.log('encrpt pass : ' + this.userPs)
        //decrption test
        //console.log('decrpt pass : ' + AesDecrypt(this.userPs))
        resolve(true)
      })
    },
    // 패스워드 display ***처리
    getUserPsHide(rowData) {
      return (rowData = '********')
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////

    btnSearch() {
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')
      getUserListByCompId({ compId: '', menuId: 2004 }, true)
        .then(response => {
          if (response.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.gridMain = []
            this.gridMain = response.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnAdd() {
      // const password = Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000
      let password = ''
      for (let i = 0; i < 10; i++) {
        password += Math.floor(Math.random() * 10)
      } // 패스워드 난수 생성
      let newRow = {
        id: this.gridMain.length + 1,
        userPs: password,
        userPsCheck: password,
        useYn: 'Y',
        psChked: 'Y',
        hpNo: '',
        groupId: this.groupKey,
        // userStatus: 'W',
        enableAlarmAllYn: 'Y',
        enableAlarmEduYn: 'Y',
        enableAlarmHealthYn: 'Y'
      }
      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    async btnSave() {
      //20220630 LYJ selectedRows 정의되지않아 에러남 추가함 start [[
      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }
      //20220630 LYJ selectedRows 정의되지않아 에러남 추가함 end ]]
      //패스워드 암호화 적용여부

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        async current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          var pattern = /\s/g
          var index = selectedRows.findIndex(
            element =>
              element.userCd == null ||
              element.userNm == null ||
              element.clntId == null ||
              element.useYn == null ||
              element.grpAuthCd == null ||
              (element.psChked == 'Y' && element.userPs == null && element.userPsCheck == null) ||
              element.userCd == '' ||
              element.userNm == '' ||
              element.clntId == '' ||
              element.useYn == '' ||
              element.grpAuthCd == '' ||
              element.userCd.match(pattern) != null
          )
          if (index >= 0) {
            this.vToastify(this.$t('필수항목 입력해주세요.[아이디, 사용자 명, 패스워드, 패스워드확인, 권한그룹, 고객 정보, 상태]'), 'warn')
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }

          //패스워드 패스워드 확인 값비교
          let index2 = selectedRows.findIndex(element => element.userPs != element.userPsCheck)
          if (index2 >= 0) {
            this.vToastify(this.$t('패스워드와 패스워드확인이 일치하지 않습니다.'), 'warn')
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }

          //유효성 검사
          var valid = ''
          var patternIndex = selectedRows.findIndex(element => {
            console.log(element.hpNo)
            if (!(element.hpNo == '' || element.hpNo == undefined || element.hpNo == null) && element.hpNo.match(this.phonePattern) == null) {
              valid = 'hpNo'
              return true
            }
          })
          if (patternIndex >= 0) {
            this.vToastify(valid == 'hpNo' ? this.$t('올바르지 않은 휴대전화번호 형식입니다.') : this.$t(''), 'warn')
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }
          // 유효성검사가 끝난 비밀번호 암호화 처리
          if ({ psChked: 'Y' }) {
            await this.signIn()
          } else {
            this.psInit()
          }

          // selectedRows.forEach(element => {
          //   element.__created__ = true
          // })
          console.log('btnSave:', selectedRows)
          this.openLoading('saving')
          //저장 api
          saveUserList(selectedRows, true)
            .then(res => {
              this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
              this.btnSearch(false)
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnDelete() {
      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          this.openLoading('deleting')
          //삭제 api
          deleteUserList(selectedRows, true)
            .then(response => {
              this.deleteCallBack(selectedRows)
              this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    // onValueChanged(e, selectRows){
    //   console.log(selectRows)
    //   selectRows.setValue(e.value)
    // },
    // onHrValueChanged(e, cellInfo) {
    //   cellInfo.setValue(e.value)
    //   cellInfo.component.selectRows(cellInfo.row.key, true)
    // },
    onCheckValueChangedPs(value, selectRows) {
      selectRows.setValue(selectRows.value === 'Y' ? 'N' : 'Y')
      selectRows.component.updateDimensions()
    },

    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },

    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      console.log('onCellValueChanged', cellInfo.rowIndex)
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    },

    psInit() {
      var selectedRows = this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      selectedRows.forEach(element => {
        element.userPs = null
        element.userPsCheck = null
      })
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.gridMain.findIndex(obj => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    //추가된 행이 아니면 수정 불가능하게 설정
    onEditingStart(e) {
      // if ((e.column.dataField == 'userCd' && !e.data.__created__) || (e.column.dataField == 'compId' && !e.data.__created__)) e.cancel = true
      if (e.column.dataField == 'userCd' && !e.data.__created__) e.cancel = true
      else e.cancel = false

      if ((e.column.dataField == 'userPs' && e.data.psChked != 'Y') || (e.column.dataField == 'userPsCheck' && e.data.psChked != 'Y')) e.cancel = true
      if (e.column.dataField == 'loginFailCnt' || e.column.dataField == 'clntNm' || e.column.dataField == 'compNm') e.cancel = true
    },
    //로우 포커스 이벤트
    handleFocusedRow(e) {
      if (e.row != undefined) {
        if (e.row.rowType === 'group') {
          this.groupKey = e.row.key[0]
        } else {
          this.groupKey = e.row.data.compId
        }
        console.log('this.groupKey', this.groupKey)
      }
    },
    onDateValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`
      //그리드 삽입
      const cell = cellInfo.data
      cell[cellInfo.column.dataField] = dateFormat
      cellInfo.setValue(dateFormat)
      this.$refs[this.dxDataGridRef].instance.selectRows(cellInfo.row.key, true)
    },
    initialize(data) {
      this.vToastifyPrompt(
        this.$t(
          '비밀번호를 초기화하시겠습니까? </br> 초기화된 비밀번호는 해당 유저가 속한 고객사의 사업자 등록번호 입니다. <br> 초기화된 비밀번호: ' +
            data.rgstNo
        ),
        'info',
        async current => {
          this.openLoading('saving')
          initPassword(data)
            .then(response => {
              console.log('response', response)
            })
            .finally(() => {
              this.endLoading()
              this.btnSearch(false)
            })
        },
        null,
        true
      )
    },
    onSelectionChanged(e, cellInfo, list, key) {
      let data = list.find(el => el[key] == e.selectedRowKeys[0])
      cellInfo.component.cellValue(cellInfo.row.rowIndex, key, data[key])

      //다른 고객 선택 시 사업장 확인 후 초기화

      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    },
    clntDisplay(cellInfo) {
      let obj = this.clntIdList.find(element => element.clntId == cellInfo.row.data.clntId)
      return obj ? obj.clntNm : ''
    }
  }
}
</script>

<style scoped></style>
